module.exports = __webpack_public_path__ + "img/1a47222.png";